import { ProductSizeLabelType } from "../ProductSizeLabelType.js";

export const productSizeLabelTypeShorthandNameMap = {
	[ProductSizeLabelType.Grams]: "g",
	[ProductSizeLabelType.Kilograms]: "kg",
	[ProductSizeLabelType.Pieces]: "ks",
} satisfies Record<Exclude<ProductSizeLabelType, ProductSizeLabelType.Serving>, string>;
